/** Known apps of shared worker */
export enum AppId {
  RESOLVE = 'RESOLVE',
  EVENTQ = 'EVENTQ',
}

export interface SharedWorkerConfig {
  appId: AppId;
  workerUrl?: string;
}

export type SharedWorkerClientMessage =
  | { type: 'register'; clientId: string; appId: AppId }
  | { type: 'unregister' }
  | { type: 'heartbeat' }
  | { type: 'broadcast'; event: string; payload: unknown };

export type SharedWorkerServerMessage =
  | {
      type: 'registered';
      clientId: string;
      appId: AppId;
      apps: Record<AppId, boolean>;
      /** True when this client is the primary (lease holder) for its AppId. */
      isPrimary: boolean;
    }
  | { type: 'presence-changed'; apps: Record<AppId, boolean> }
  | { type: 'broadcast'; event: string; payload: unknown; fromAppId: AppId | null }
  | { type: 'heartbeat-check'; fromAppId: AppId | null }
  | {
      /** Sent when this client's primary status changes (elected or revoked). */
      type: 'primary-changed';
      appId: AppId;
      isPrimary: boolean;
    };

/**
 * Default SharedWorker script URL (same-origin via YARP / mock static `/workers`).
 * Query param busts browser SharedWorker process cache when the script changes
 * (primary-lease election must load; stale workers omit `isPrimary` and break single-instance UI).
 */
export const SHARED_WORKER_DEFAULT_URL = '/workers/ebm-shared-worker.js?v=primary-4';

/**
 * Event name used when broadcasting a workspace snapshot via the SharedWorker.
 * Either app can send this to inform the sibling of its current workspace state.
 */
export const WORKSPACE_SNAPSHOT_EVENT = 'workspace.snapshot';

/** Payload carried by a `workspace.snapshot` SharedWorker broadcast. */
export interface WorkspaceSnapshotPayload {
  /** Sending AppId (EVENTQ or RESOLVE). */
  appId: AppId;
  /** ISO timestamp when the snapshot was taken. */
  snapshotAt: string;
  /** Opaque workspace state JSON — consuming apps decide the schema. */
  data: unknown;
}
